import React, { useState } from "react";
import { FaArrowCircleUp } from "react-icons/fa";


const ScrollButton = () => {
    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 1000) {
            setVisible(true);
        } else if (scrolled <= 1000) {
            setVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            /* you can also use 'auto' behaviour
         in place of 'smooth' */
        });
    };

    window.addEventListener("scroll", toggleVisible);

    return (
        <>
        <div className="btn-scroll-to-top">
            <FaArrowCircleUp
                onClick={scrollToTop}
                style={{ display: visible ? "inline" : "none" , 
                    boxShadow: "-1px 5px 5px #808080", 
                    borderRadius: "50px",
                    backgroundColor: "#fff"
                }}
            />
        </div>
        </>
    );
};

export default ScrollButton;